import { AppConfig } from '@ltvco/refresh-lib/ctx';
import {
  FirstRecordSearch,
  RecordSearchDataWithType,
  getFirstRecordSearch,
} from '@ltvco/refresh-lib/utils';
import { useAccount } from '@ltvco/refresh-lib/v1';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useState, useEffect, useContext } from 'react';

type FirstRecordSearchData =
  | FirstRecordSearch
  | RecordSearchDataWithType
  | null;

export const useFirstRecordSearch = () => {
  const { routingUtils } = useContext(AppConfig);
  const isInFirstPDFVariation = useFeatureIsOn('RFRSH-3379');

  const [firstRecordSearchData] = useState<FirstRecordSearchData>(
    getFirstRecordSearch(routingUtils)
  );

  const { data: account } = useAccount(true);

  const hadFirstSearch = !!firstRecordSearchData;
  const [showFirstTimePDFModal, setFirstTimePDFModal] = useState(false);

  useEffect(() => {
    if (!account) {
      return;
    }

    if (hadFirstSearch) {
      setFirstTimePDFModal(
        isInFirstPDFVariation &&
          !account?.account?.subscription_info?.subscription_features
            ?.pdf_access
      );
    }
  }, [account]);

  return {
    firstRecordSearchData,
    showFirstTimePDFModal,
  };
};
